<!-- 企业级-授权管理-授权中心-已授权用户 -->
<template>
  <div class="mainArea CBeAuthorizedUser">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="infoTip">
        <span>设备ID：{{device_no_id}}</span>
        <span>设备名称：{{device_name}}</span>
        <span>设备类型：{{device_type}}</span>
      </div>
      <div class="mainBodyContent">
        <div class="searchDiv flex">
          <div class="flex">
            <el-select v-model="userType" placeholder="请选择用户类型" class="mr20" clearable @change="getAuthorizedUserList(1)">
              <el-option v-for="(item,index) in typeList" :label="item.name" :value="item.id" :key="index"></el-option>
            </el-select>
            <el-select v-model="department" placeholder="请选择部门" class="mr20" clearable @change="getAuthorizedUserList(1)">
              <el-option v-for="(item,index) in departList" :label="item.name" :value="item.id" :key="index"></el-option>
            </el-select>
            <div class="mr20"><el-input placeholder="请输入姓名" v-model="keyname" class="w200" @keyup.enter.native="getAuthorizedUserList(1)"></el-input></div>
            <div class="mr20"><el-input placeholder="请输入账号" v-model="keyuser"  @keyup.enter.native="getAuthorizedUserList(1)"></el-input></div>
            <el-select v-model="shareType" placeholder="请选择分享权限类型" class="mr20" clearable @change="getAuthorizedUserList(1)">
              <el-option v-for="(item,index) in shareTypeList" :label="item.name" :value="item.id" :key="index"></el-option>
            </el-select>
            <div><el-button type="primary" @click="getAuthorizedUserList(1)">搜索</el-button></div>
            <!-- <el-input placeholder="请输入账号" v-model="keyuser"  @keyup.enter.native="">
              <el-button slot="append" type="primary">搜索</el-button>
            </el-input> -->
          </div>
        </div>
        <!-- <div class="operDiv">
          <el-button type="primary" @click="openAuth">授权用户</el-button>
        </div> -->
        <div class="tableCont mt20">
          <el-table :data="userData" style="width: 100%" v-loading="isLoading">
            <el-table-column type="index" label="序号" width="90px"></el-table-column>
            <el-table-column prop="user_type" label="用户类型"></el-table-column>
            <el-table-column prop="department_name" label="部门"></el-table-column>
            <el-table-column prop="user_name" label="姓名"></el-table-column>
            <el-table-column label="账号">
              <template slot-scope="scope">
                <el-button type="text" @click="toUserPage(scope.row)">{{ scope.row.account }}</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="box_number" label="箱格号" v-if="isShow"></el-table-column>
            <el-table-column label="授权时间">
              <template slot-scope="scope">
                <span v-if="scope.row.use_timetype==0">永久</span>
                <span v-else>{{scope.row.start_usetime}}~{{scope.row.end_usetime}}</span>
              </template>
            </el-table-column>
            <el-table-column label="使用次数">
              <template slot-scope="scope">
                <span v-if="scope.row.use_count!='-1'">{{scope.row.use_count}}</span>
                <span v-else>无限次数</span>
              </template>
            </el-table-column>
            <el-table-column label="分享权限">
              <template slot-scope="scope">
                <span>{{scope.row.is_share == 1 ? '允许' : '禁止'}}分享</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="openEditDio(scope.$index)">修改授权</el-button>
                <el-button type="text" @click="openStatus(scope.$index)">取消授权</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging" v-if="total>page">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="page"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <!--修改授权-->
      <el-dialog title="修改授权" :visible.sync="editAuthDio" width="600px" class="authDio">
        <div class="contDio">
          <el-form ref="form" :rules="rules" :model="editform" label-width="90px">
            <el-form-item label="授权时间:">
              <el-select v-model="editform.timeType" class="w110">
                <el-option
                  v-for="(item,index) in authTypeList"
                  :key="index"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <template v-if="editform.timeType==1">
              <el-date-picker
                v-model="editform.time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                :default-time="['00:00:00','23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
              </template>
            </el-form-item>
            <el-form-item label="使用次数:">
              <el-checkbox v-model="editform.isCount">无限次数</el-checkbox>
              <template v-if="editform.isCount == false">
              <el-input v-model="editform.frequency" class="w110"></el-input><span> 次</span>
              </template>
            </el-form-item>
            <el-form-item label="分享权限:">
              <el-checkbox v-model="editform.is_forbid">禁止分享</el-checkbox>
              <span class="hintColor">勾选后，授权用户将无法使用分享设备权限功能</span>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitEdit('form')">确定</el-button>
        </span>
      </el-dialog>
      <!--取消授权-->
      <el-dialog title="" :visible.sync="statusDio" width="300" class="statusDio">
        <div class="statusCont">
          <div>是否取消授权？</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="statusDio = false">取 消</el-button>
          <el-button type="primary" @click="delAuthUser">确定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { userApi, authApi } from "../../../../static/js/api.js"

  export default {
    name: 'CBeAuthorizedUser',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        device_no_id:'',//设备ID
        device_type:'',//设备类型
        device_name:'',//设备名

        userType:'',//用户类型
        typeList:[{
          id:0,
          name:'内部员工'
        },
        // {
        //   id:1,
        //   name:'会员用户'
        // },
        {
          id:2,
          name:'临时用户'
        }],
        department:'',//部门
        departList:[],
        keyname:'',//姓名
        keyuser:'',//账号
        shareType: '', // 分享类型

        isLoading:false,
        userData:[],//授权用户数据
        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据

        editAuthDio:false,//修改授权
        editform:{
          id:'',
          box_number:'',
          timeType:'',//类型
          time:'',//时间
          frequency:'',//使用次数
          isCount:false,
          is_forbid: false
        },
        rules:{
          frequency:[
            { required: true, message: '请输入使用次数', trigger: 'blur' },
          ]
        },
        pickerOptions:{
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的 
         }
       },
        //时间类型数组
        authTypeList:[{
          id:'1',
          name:'指定时间',
        },{
          id:'0',
          name:'永久',
        }],

        statusDio:false,//取消授权弹窗
        userauth_id:'',
        userbox_number:'',

        // 分享类型列表
        shareTypeList: [
          {
            name: '允许分享',
            id: 1,
          },
          {
            name: '禁止分享',
            id: 0
          },
        ],

        isShow:false,
      }
    },
    mounted(){
    },
    created: async function () {
      this.device_no_id=this.$route.query.device_no_id
      this.device_type=this.$route.query.device_type
      this.device_name=this.$route.query.device_name
      this.getAllDepartment();
    },
    methods: {
      //打开删除弹窗
      openStatus(index){
        this.userauth_id = this.userData[index].id
        this.userbox_number = this.userData[index].box_number
        this.statusDio = true;
      },
      //删除授权用户
      async delAuthUser(){
        let that = this;
        let data = {
          'id': that.userauth_id,//授权用户id
        }
        if(this.isShow == true){
          data.box_number = that.userbox_number
        }
        let res = await authApi.delAuthorizedUser(data)
        if (res.meta.code === 200) {
          that.getAuthorizedUserList()
          that.statusDio = false;
          showToast('删除授权成功！')
        } else {
          showToast(res.meta.message)
        }
      },
      //提交修改
      submitEdit(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.updateAuthorizedUser();
          } else {
            return false;
          }
        });
      },
      //更新用户授权
      async updateAuthorizedUser(){
        let that = this;
        let data = {
          'id': that.editform.id,//授权用户id
          // 'use_count': that.editform.frequency,//使用次数
          'use_timetype': that.editform.timeType,//授权时间类型
          'is_share': that.editform.is_forbid ? 0 : 1, // 是否有设备分享权限 
        }
        if(that.isShow == true){
          data.box_number = that.editform.box_number
        }
        if(that.editform.isCount == true){
          data.use_count='-1'
        }else{
          var re = /^[1-9]+[0-9]*]*$/
          if(!re.test(that.editform.frequency)){
            showToast('使用次数只能输入正整数')
            return
          }else{
            data.use_count=that.editform.frequency
          }
        }
        if(that.editform.timeType == 1){
          data.start_usetime=that.editform.time[0]
          data.end_usetime=that.editform.time[1]
        }
        let res = await authApi.updateAuthorizedUser(data)
        if (res.meta.code === 200) {
          that.getAuthorizedUserList(1)
          that.editAuthDio = false;
          showToast('更新授权成功！')
        } else {
          showToast(res.meta.message)
        }
      },
      //打开修改授权弹窗
      openEditDio(index){
        let that = this;
        this.editform.id = this.userData[index].id
        this.editform.box_number = this.userData[index].box_number
        this.editform.timeType = this.userData[index].use_timetype
        this.editform.is_forbid = this.userData[index].is_share == 0
        if(this.userData[index].use_count == '-1'){
          that.editform.isCount = true
        }else{
          that.editform.frequency=that.userData[index].use_count
        }
        if(this.userData[index].use_timetype == 1){
          let time =[]
          time.push(that.userData[index].start_usetime)
          time.push(that.userData[index].end_usetime)
          that.editform.time=time
        }
        this.editAuthDio = true;
      },
      //获取授权用户列表
      async getAuthorizedUserList(curr,limits){
        let that = this;
        this.isLoading=true;
        let data = {
          'space_id': that.$route.query.space_id,//空间ID
          'device_no_id': that.$route.query.device_no_id,//设备号
          'user_type': that.userType,//用户类型
          'department_id': that.department,//部门ID
          'user_name': that.keyname,//用户姓名
          'account': that.keyuser,//账号
          'is_share': that.shareType, // 分享类型
          'page': curr ? curr: that.curr,//当前页
          'perPage': limits ? limits:that.page,//每页条数
        }
        let res = await authApi.getAuthorizedUserList(data)
        if (res.meta.code === 200) {
          for(let i in res.data.list){
            if(res.data.list[i].box_number == ''){
              that.isShow = false
            }else{
              that.isShow = true
            }
          }
          that.userData = res.data.list
          that.isLoading=false;
          that.total = parseInt(res.data.total)
        } else {
          that.isLoading=false;
          showToast(res.meta.message)
        }
      },
      //获取部门
      async getAllDepartment(){
        let that = this;
        let data = {
          'id': '',
        }
        let res = await userApi.getAllDepartment(data)
        if (res.meta.code === 200) {
          that.departList= res.data;
          that.getAuthorizedUserList(1);
        } else {
          showToast(res.meta.message)
        }
      },

      //用户分页
      CurrentChange(val) {
        this.curr = val
        // console.log(`当前页: ${val}`);
        this.getAuthorizedUserList(val);
      },

      toUserPage(item) {
        
        let path;
        if (item.user_type_int == 4) {
          //内部员工
          path = 'COrganizeManage';
        } else if (item.user_type_int == 12) {
          //临时用户
          path = 'CCasualUser';
        }

        if (path) {
          this.$router.push({path: path, query: {phone_no: item.account}});
        }
        return;
      }
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss">
// .mainBodyContent{
//   height: calc(100vh - 255px);
//   overflow-y:auto; 
// }
.mainBodyContent{
  margin-top: 15px;
}
.CBeAuthorizedUser{
  .el-dialog__body{
    padding:10px 20px;
  }
  .flex{
    display: flex;
  }
  .w110{ width: 110px;}
  .w200{ width: 200px;}
  .mr20{ margin-right: 20px;}
  .mt20{ margin-top: 20px;}
  .infoTip{
    background: #fff;
    padding: 20px;
    margin:20px 30px 0;
    border-radius: 10px;
    span{ margin-right: 40px;}
  }
  .searchDiv{
    justify-content: space-between;
  }
  .operDiv{
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  } 
  .hintColor {
    color: #f95757;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CAuthorizationManage/CBeAuthorizedUser.vue